//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, onMounted } from '@vue/composition-api'
import { mdiShare} from '@mdi/js'
import { avatarText } from '@core/utils/filter'
import { useUtils } from '@core/libs/i18n'

// import { logUserActivity } from '@api'
import useCryptoJs from '@core/utils/useCryptoJs'
import useShare from '@core/utils/useShare'
import videojs from 'video.js'

export default {
  name: 'HighlightList',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    highlights: {
      type: Array,
      default: () => [],
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    isPrivate: {
      type: Boolean,
      default: false,
      required: true,
    },
    ipAddress: {
      type: Object,
      default: () => {},
      required: true,
    },
    matchCode: {
      type: String,
      default: '',
      required: true,
    },
  },
  setup(props) {
    const { shareFile } = useShare()
    const { userData } = useCryptoJs()
    const { t } = useUtils()

    const USER_ACT_SHARE_HIGHLIGHT_LANDING_APP = 'Share Highlight Landing App'

    const playerOptions = ref({
      controls: true,
      responsive: true,
      breakpoints: true,
      fill: true,
      autoplay: false,
      muted: true,
      loop: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [],
      poster: 'https://fanaty-general-ohio.s3.us-east-2.amazonaws.com/no-thumb.jpg',
      notSupportedMessage: 'Este video no está disponible temporalmente, intente nuevamente más tarde.',
      usingPlugin: true,
      fluid: true,
      aspectRatio: '16:9',
    })

    const computedTitle = computed(() => props.title)
    const computedHighlights = computed(() => props.highlights)
    const computedIsPrivate = computed(() => props.isPrivate)
    const computedIpAddress  = computed(() => props.ipAddress)
    const computedMatchCode  = computed(() => props.matchCode)

    const getLog = (reference) => {
      const log = {
        ip_address: computedIsPrivate.value ? null : computedIpAddress.value.ip,
        user_id: computedIsPrivate.value ? userData.value.user_id : null,
        match_code: computedMatchCode.value,
        reference: reference,
        action: USER_ACT_SHARE_HIGHLIGHT_LANDING_APP,
      }

      return log
    }

    onMounted(async () => {
      computedHighlights.value.forEach((e, i) => {
        let playerOpt = playerOptions.value
        playerOpt.sources = []
        playerOpt.poster = e.thumbnail
        playerOpt.sources.push({
          type: 'video/mp4',
          src: e.highlight_url,
        })

        const getPlayer = videojs.getPlayer(`highlightVideo${i}`)
        if (getPlayer) getPlayer.dispose()
        const player = videojs(`highlightVideo${i}`, playerOpt)
      })
    })

    return {
      // data
      USER_ACT_SHARE_HIGHLIGHT_LANDING_APP,
      playerOptions,
      userData,

      // computed
      computedTitle,
      computedHighlights,
      computedIsPrivate,
      computedIpAddress,
      computedMatchCode,

      //methods
      avatarText,
      shareFile,
      getLog,

      // i18n
      t,

      // icons
      icons: {
        mdiShare,
        sendIcon: require('@/assets/images/svg/send.svg')
      }
    }
  },
}
